import { NavLink } from 'react-router-dom';
import { CSSProperties, forwardRef, ReactNode } from 'react';

export type NavLinkAdapterPropsType = {
  activeClassName?: string;
  activeStyle?: CSSProperties;
  children?: ReactNode;
  to?: string;
  href?: string;
  className?: string;
  style?: CSSProperties;
  role?: string;
  exact?: boolean;
};

/**
 * The NavLinkAdapter component is a wrapper around the Next.js Link component.
 * It adds the ability to navigate programmatically using the useRouter hook.
 * The component is memoized to prevent unnecessary re-renders.
 */
const NavLinkAdapter = forwardRef<HTMLAnchorElement, NavLinkAdapterPropsType>((props, ref) => {
  const { activeClassName = 'active', activeStyle, role = 'button', to, href, exact = false, ..._props } = props;
  const targetUrl = to || href;

  return (
    <NavLink
      role={role}
      to={targetUrl}
      className={({ isActive }) => [_props.className, isActive ? activeClassName : null].filter(Boolean).join(' ')}
      style={({ isActive }) => ({
        ..._props.style,
        ...(isActive ? activeStyle : null)
      })}
      {..._props}
    >
      {props.children}
    </NavLink>
  );
});

export default NavLinkAdapter;
